import { Component } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth'; 

import * as firebase from 'firebase/app';
import { FirebaseUISignInSuccess } from 'firebaseui-angular'; 


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})
export class AppComponent {
  items: Observable<any[]>;
  constructor(db: AngularFirestore, public afAuth: AngularFireAuth) {
    this.items = db.collection('items').valueChanges();
  }

  login() {
      const authProvider = new firebase.auth.GoogleAuthProvider();
      authProvider.addScope('https://www.googleapis.com/auth/drive');
      // "https://www.googleapis.com/auth/drive.file",
       // Required to identify the user in our data store.
      authProvider.addScope('https://www.googleapis.com/auth/userinfo.email');
      authProvider.addScope('https://www.googleapis.com/auth/userinfo.profile');
      //authProvider.setCustomParameters()

      this.afAuth.auth.signInWithPopup(authProvider);
    }
    logout() {
      this.afAuth.auth.signOut();
    }

    successCallback(signInSuccessData: FirebaseUISignInSuccess) {
      alert(signInSuccessData.currentUser);
    }

}



// WEBPACK FOOTER //
// /Users/neerajvyas/Documents/pointtoshare/p2sfirebase2/PointToShare/src/app/app.component.ts